import { Injectable } from '@angular/core';
import { ColDef, IDateFilterParams } from 'ag-grid-community';
import {
  dblclickTooltipDef,
  defaultColumn,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { cloneDeep } from 'lodash';
import { AdministratorFacade, getRolesAndPermission } from '@piqet-angular/data';
import * as moment from 'moment';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class LoginLogsGridService {
  showHistory = new Subject<[any, any]>();
  loginLogs$ = this.showHistory.asObservable();

  constructor(public admnistratorFacade: AdministratorFacade) {}

  getAdministratorLoginLogsColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Name',
      field: 'name',
      minWidth: grid_widths_map.lg_column_sm,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      comparator: () => 0,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        cellElement.style.cursor = 'pointer';
        cellElement.style.textDecoration = 'underline';
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          this.showHistory.next([params.data, 'Review login history detail']);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'LastLogin',
      headerName: 'Last login',
      field: 'lastLogin',
      maxWidth: grid_widths_map.sm_column_xxl,
      minWidth: grid_widths_map.sm_column_xxl,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      filterParams: this.filterParams,
      comparator: () => 0,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Login history',
      field: 'actions',
      sortable: false,
      maxWidth: grid_widths_map.sm_column_xss,
      cellRendererParams: {
        showEdit: this.isAccess() ? this.isAccess().isEdit : false,
        showDetails: this.isAccess() ? this.isAccess().isEdit : true,
        showDetailsData: (data: any) => {
          this.showHistory.next([data, 'Review login history detail']);
        },
      },
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      resizable: false,
      lockVisible: true,
      lockPosition: right,
    });

    return colDef;
  }

  isAccess = () => {
    return getRolesAndPermission(
      rolesModuleName.AdministratorLoginlogs,
      mainModuleName.administratorModule
    );
  };

  getNewProcessColumns(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'LoginDate',
      headerName: 'Login date',
      field: 'loginDate',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      comparator: () => 0,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'LoginTime',
      headerName: 'Login time',
      field: 'loginTime',
      maxWidth: grid_widths_map.sm_column_xxl,
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      valueFormatter: this.timeFormatter,
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      comparator: () => 0,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Ipaddress',
      headerName: 'Login IP',
      field: 'ipaddress',
      minWidth: grid_widths_map.sm_column_xl,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      comparator: () => 0,
    });
    return colDef;
  }

  timeFormatter(time: any) {
    const timeWithoutSeconds = time?.value.substring(0, 5);
    return timeWithoutSeconds;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  filterParams: IDateFilterParams = {
    comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
      const dateAsString = cellValue;
      if (dateAsString == null) return -1;
      const dateParts = dateAsString.split('/');
      const cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0])
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    minValidYear: 2000,
    maxValidYear: 2021,
    inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
  };
}
